import { Checkbox } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

export default withStyles({
  root: {
    padding: 0,
  }
})(Checkbox);